import React from "react";
import { Box, Container, Typography, Grid, Stack } from "@mui/material";
import { motion } from "framer-motion";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const MONO   = "'JetBrains Mono', 'Fira Code', ui-monospace, monospace";
const ACCENT = "#E2684A";
const PURPLE = "#7C3AED";
const BG     = "#030014";
const BG2    = "#0F0728";
const LINE   = "#1E2130";
const INK    = "#E7E9EE";
const INK2   = "#B6BBC6";
const R      = "14px";

const BenefitsSection = ({ title, subtitle, benefits }) => (
  <Box sx={{ py: { xs: 10, md: 13 }, borderBottom: `1px solid ${LINE}`, background: BG }}>
    <Container maxWidth="lg">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55 }}
        viewport={{ once: true }}
      >
        <Typography sx={{ fontFamily: MONO, fontSize: "12px", letterSpacing: "0.16em", textTransform: "uppercase", color: ACCENT, mb: 1.75 }}>
          {subtitle || "Why Choose Us"}
        </Typography>
        <Typography sx={{
          fontFamily: "'IBM Plex Serif', serif",
          fontSize: { xs: "1.75rem", md: "2.5rem" },
          fontWeight: 600, letterSpacing: "-0.015em", lineHeight: 1.15,
          color: INK, maxWidth: 720, mb: 6,
        }}>
          {title}
        </Typography>
      </motion.div>

      <Grid container spacing={2}>
        {benefits.map((benefit, index) => (
          <Grid item xs={12} md={6} key={index}>
            <motion.div
              initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.45, delay: index * 0.08 }}
              viewport={{ once: true }}
              style={{ height: "100%" }}
            >
              <Box sx={{
                display: "flex", gap: 2.5, p: "20px 22px", height: "100%",
                borderRadius: R, background: BG2, border: `1px solid ${LINE}`,
                transition: "border-color 0.2s",
                "&:hover": { borderColor: `${ACCENT}60` },
              }}>
                {/* Icon/number */}
                <Box sx={{
                  minWidth: 40, height: 40, borderRadius: "10px", flexShrink: 0,
                  background: "rgba(226,104,74,0.12)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  color: ACCENT, mt: 0.25,
                }}>
                  {benefit.icon || <CheckCircleOutlineIcon fontSize="small" />}
                </Box>

                <Box>
                  <Typography sx={{ fontWeight: 600, color: INK, fontSize: "15.5px", mb: 0.6 }}>
                    {benefit.title}
                  </Typography>
                  <Typography sx={{ color: INK2, fontSize: "14px", lineHeight: 1.7 }}>
                    {benefit.description}
                  </Typography>
                </Box>
              </Box>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default BenefitsSection;
